import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styels = {};

class Bank extends React.Component {
  renderBank = () => {
    const { bank } = this.props;
    return (
      <div>
        <Typography variant="title" gutterBottom>
          Bank details
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Bank Name</TableCell>
              <TableCell>Account No</TableCell>
              <TableCell>BSB No</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                {bank.bankName}
              </TableCell>
              <TableCell>
                {bank.AccountNo}
              </TableCell>
              <TableCell>
                {bank.BSB}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    );
  }

  render = () => {
    return (
      <div>
        {this.renderBank()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
const reduxed = connect(mapStateToProps)(Bank);
export default withStyles(styels)(reduxed);



// WEBPACK FOOTER //
// ./src/components/Loans/Bank.js